module.exports = __webpack_public_path__ + "static/Royal_Blue_Grocery_pin_hover-019382a5c866f9b4250d6506a9cf740f.png";